/* eslint-disable react/prop-types */
import { avatar } from "@/assets";
import { cn, resolveImageUrl } from "@/lib/utils";
import { useNavigate } from "react-router-dom";
import { Confirm } from "notiflix";
import { LogOut } from "lucide-react";
import { useSelector } from "react-redux";
import { PostRequest } from "@/lib/http";

const Footer = ({ className }) => {
  const user = useSelector((state) => state.user.user);

  const navigate = useNavigate();
  const confirmation = async () => {
    Confirm.show(
      "Confirm Action",
      `Are you sure you want to logout?`,
      "Yes, Proceed",
      "Cancel",
      async () => {
        navigate("/login");
        localStorage.removeItem("user-token");
        PostRequest({
          url: "/api/admin/logout",
        });
      },
    );
  };
  return (
    <>
      <div
        className={cn(
          "font-jakarta flex items-center justify-between lg:py-2",
          className,
        )}
      >
        <div className="flex flex-1 items-center gap-1">
          <img
            src={user.avatar ? resolveImageUrl(user.avatar) : avatar}
            alt="avatar"
            className="size-10 rounded-full object-cover"
          />

          <div>
            <h4 className="font-geist text-sm leading-none font-semibold text-black dark:text-white">
              {user?.name}
            </h4>
            <p className="dark:text-darkGray w-[150px] overflow-hidden text-sm font-medium text-ellipsis whitespace-nowrap text-gray-500">
              {user?.email}
            </p>
          </div>
        </div>

        <LogOut
          size={22}
          onClick={confirmation}
          className="cursor-pointer text-black dark:text-white"
        />
      </div>
    </>
  );
};

export default Footer;
